module.exports = __webpack_public_path__ + "static/img/chapter.8189ee5a.png";